export default "__VITE_ASSET__d0561a0c__"